export class Formulaire {
    id: number|undefined;
    active:boolean;
    lien:string;
  }